<template>
    <div>
        <div class="modal fade" id="notificationModal" tabindex="-1" role="dialog"
             aria-labelledby="notificationModalLabel" aria-hidden="true">
            <div class="modal-dialog" :class="notification.notification_type === 'email' ? 'modal-lg' : ''" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="notificationModalLabel">Notification</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <form>

                            <div class="mb-3">
                                <label>What type of notification?</label>
                                <select id="notificationTypeOptions" class="form-select" v-model="notification.notification_type">
                                    <option>email</option>
                                </select>
                            </div>

                            <div v-if="isEmailNotification" class="form-group">
                                <label>Table</label>
                                <select class="form-select" v-model="emailTemplate.parentModel">
                                    <option v-for="table in model.app.tables" :value="table">{{table.name}}</option>
                                </select>
                            </div>

                            <div v-if="isEmailNotification && emailTemplate.parentModel" class="form-group">
                                <label>To Email Address</label>
                                <select class="form-select" v-model="emailTemplate.toField">
                                    <option v-for="field in emailTemplate.parentModel.fields" :value="field.index">{{field.name}}
                                    </option>
                                </select>
                                <div v-if="emailTemplate.toField === null && !isValid" class="invalid-element"
                                     style="padding-left: 15px;">
                                    A to address is required.
                                </div>
                            </div>


                            <div v-if="isEmailNotification" class="form-group">
                                <label>From Email Address</label>
                                <select class="form-select" v-model="emailTemplate.fromCollaboratorId" >
                                    <option v-for="collaborator in model.app.collaborators" :value="collaborator.id">{{collaborator.name}}</option>
                                </select>
                            </div>

                            <div class="mb-3" v-if="isEmailNotification">
                                <label for="subjectInput">Subject</label>
                                <input type="text" class="form-control" id="subjectInput" v-model="emailTemplate.subject">
                            </div>

                            <div v-if="isEmailNotification && emailTemplate.parentModel"><strong>Available fields</strong></div>

                            <div class="d-flex flex-wrap my-2" v-if="isEmailNotification && emailTemplate.parentModel">
                                <div v-for="field in emailTemplate.parentModel.fields">
                                    <span class="badge text-bg-primary m-1">{{field.name}}</span>
                                </div>
                            </div>

                            <div class="d-flex my-2" v-if="isEmailNotification && emailTemplate.parentModel">
                                <small class="text-muted">Wrap fields inside of brackets: <span v-pre>[FieldName]</span></small>
                            </div>

                            <div id="emailBodyContainer" class="form-group" v-if="isEmailNotification">
                                <label for="subjectInput">Email</label>

                                <vue3-trix-editor input-id="notificationModalTextEditor" :model-object="emailTemplate" text-field="body"
                                                  @onFocus="onFocus" @onFocusOut="onFocusOut"></vue3-trix-editor>

<!--                                <VueTrix ref="vueTrix" inputId="emailBodyInput" v-model="emailTemplate.body" placeholder="Email Content"-->
<!--                                         @trix-attachment-add="onAttachmentAdded" @trix-focus="onFocus" @trix-blur="onFocusOut"/>-->

                            </div>

                        </form>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                        <button type="button" class="btn btn-secondary" @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import NotificationService from "../services/NotificationService";
    import ImageService from "../services/ImageService";
    import Vue3TrixEditor from "../components/Vue3TrixEditor.vue";

    export default {
        name: 'notificationModal',
        components: {
            Vue3TrixEditor,
        },
        props: {
            yesEvent: Function,
            notification: Object,
            emailTemplates: Array,
            notifications: Array
        },
        computed: {
            isEmailNotification() {
                return this.notification.notification_type === 'email'
            },
            notifiableOptions() {
                let options = webase.managers.app.getIntegrationOptions()

                for (let i = 0; i < this.emailTemplates.length; i++) {
                    let emailTemplate = this.emailTemplates[i]
                    options.push({
                        name: 'Email (' + emailTemplate.subject + ')',
                        notifiable_id: emailTemplate.id,
                        notifiable_type: 'EmailTemplate'
                    })
                }


                return options
            }
        },
        data() {
            return {
                model: webase.model,
                service: new NotificationService(),
                timerId: null,
                currentField: {
                    id: null,
                    name: ''
                },
                currentModel: {
                    id: null,
                    fields: []
                },
                emailTemplate: {
                    subject: '',
                    body: '',
                    parentModel: null,
                    toField: null,
                    fromCollaboratorId: null
                },
                // notifiableObject: {
                //     name: '',
                //     notifiable_id: null,
                //     notifiable_type: ''
                // },
                isValid: true,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('notificationModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            if(this.notification.notification_type === 'email' && this.notification.metadata && this.notification.metadata.email ) {
                this.emailTemplate = this.notification.metadata.email
            }

            // if (this.notification.notifiable_id) {
            //     let currentOption = this.notifiableOptions.filter(option => (option.notifiable_id == this.notification.notifiable_id && option.notifiable_type == this.notification.notifiable_type))
            //
            //     if (currentOption.length > 0) {
            //         this.notifiableObject = currentOption[0]
            //     }
            // }

            // if (this.notification.metadata && this.notification.metadata.email && this.notification.metadata.email.toField) {
            //     this.currentField = webase.managers.app.getField(this.notification.field_id)
            // }
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
            this.onFocusOut() // make sure timer is killed
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                if (!this.isFormValid()) {
                    return
                }

                this.save()

                // call the parent's "yesEvent"
                if (this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            save() {
                this.notification.name = ''

                if(this.notification.notification_type === 'email') {
                    this.notification.metadata['email'] = this.emailTemplate
                    this.notification.name = 'Email - ' + this.emailTemplate.subject
                }
                else {
                    this.notification.metadata = {}
                }

                if (this.notification.id === null) {
                    this.create()
                } else {
                    this.update()
                }
            },
            create() {
                let request = {
                    notification: this.notification
                }

                this.service.create(request).then((response) => {
                    console.log('notification created')
                    this.notifications.push(response)
                    this.notification.id = response.id
                }).catch((message) => {
                    console.log('error creating email_template')
                    console.log(message)
                })
            },
            update() {
                let request = {
                    notification: this.notification
                }

                this.service.update(this.notification.id, request).then((response) => {
                    console.log('notification updated')
                }).catch((message) => {
                    console.log('error updating notification')
                    console.log(message)
                })
            },
            isFormValid() {
                this.isValid = this.emailTemplate.toField !== null && this.notification.notification_type !== ''
                return this.isValid
            },
            onFocus() {
                console.log('starting timer')
                this.timerId = setInterval(this.save, 5000);
                console.log('timer id: ' + this.timerId)
            },
            onFocusOut() {
                if (this.timerId) {
                    console.log('stopping timer')
                    clearInterval(this.timerId)
                }

                this.timerId = null
                this.save()
            },
            onAttachmentAdded(event) {
                let file = event.attachment.file;
                let imageService = new ImageService()
                let imageableType = 'App'
                let imageableId = this.model.app.index

                imageService.uploadImage(imageableType, imageableId, file).then((image) => {

                    let attributes = {
                        url: webase.utils.app.getBasePageUrl() + image.url,
                        href: webase.utils.app.getBasePageUrl() + image.url
                    };

                    event.attachment.setAttributes(attributes);

                }).catch((error) => {
                    console.log('Image upload error')
                    console.log(error)
                    this.model.loading = false
                    this.noHandler()
                    alert('Image upload error, ' + error)
                })
            }
        }
    }
</script>

